import { render } from "./MiTabPanels.vue?vue&type=template&id=39042f05"
import script from "./MiTabPanels.vue?vue&type=script&lang=js"
export * from "./MiTabPanels.vue?vue&type=script&lang=js"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanels});
